import { getAuthToken } from '@dynamic-labs/sdk-react-core';
import { DocumentNode } from 'graphql';

import { GET_USER } from '@repo/api-core-toolkit';
import { PublicUser } from '@repo/types-client';

import { sendGraphqlRequest } from '../graphql';

type Props = {
  username?: string;
  email?: string;
  userId?: string;
  address?: string;
};

/**
 * Fetches a public user based on provided criteria.
 * @function getPublicUser
 * @param {Props} props - The properties to search for the user.
 * @param {string} [props.username] - The username of the user.
 * @param {string} [props.email] - The email of the user.
 * @param {string} [props.userId] - The user ID.
 * @param {string} [props.address] - The wallet address of the user.
 * @returns {Promise<PublicUser>} The public user data.
 */
export const getPublicUser = async ({
  username,
  email,
  userId,
  address,
}: Props): Promise<PublicUser> => {
  const result = await sendGraphqlRequest<PublicUser>({
    authToken: getAuthToken(),
    query: GET_USER as DocumentNode,
    variables: {
      where: {
        dynamicId: userId,
        username,
        email,
        address,
      },
    },
    field: 'getUser',
  });

  return {
    ...result,
    walletAddresses: result.wallets.ethereum.map((x) =>
      x.address.toLowerCase(),
    ),
  };
};
